<template>
<div class="lg:flex mainlogo">
        <span class="text-lg font-bold ">
            <img src="@/assets/crystaSureLogo.svg" alt=""  v-if="isSidebarToggle" class="crystaSureLogo"/>
            <img src="@/assets/crystaSureShield.svg" alt="" v-else  class="crystaSureShield"/>

        </span>
    </div>
    <div class="fixed h-full bg-white sidenav flex flex-col justify-between z-50 sideheight" :class="{ 'w-40': isSidebarToggle, 'w-10': !isSidebarToggle }">
        <ul class="sideLabels">
            <li
                @mouseover="displayToolTipMethod('dashboard', 'Dashboard')"
                @mouseout="hideToolTip()"
                @click="navigate('dashboard', 'dashboard')"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover"
                :class="selectedOptionName === 'dashboard' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="dashboard">
                                <g id="SVGRepo_iconCarrier">
                                    <path id="Vector" d="M6.75 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V8.25C1.5 9.07843 2.17157 9.75 3 9.75H6.75C7.57843 9.75 8.25 9.07843 8.25 8.25V3C8.25 2.17157 7.57843 1.5 6.75 1.5Z" fill="black" />
                                    <path id="Vector_2" d="M15 1.5H11.25C10.4216 1.5 9.75 2.17157 9.75 3V5.25C9.75 6.07843 10.4216 6.75 11.25 6.75H15C15.8284 6.75 16.5 6.07843 16.5 5.25V3C16.5 2.17157 15.8284 1.5 15 1.5Z" fill="black" />
                                    <path id="Vector_3" d="M6.75 11.25H3C2.17157 11.25 1.5 11.9216 1.5 12.75V15C1.5 15.8284 2.17157 16.5 3 16.5H6.75C7.57843 16.5 8.25 15.8284 8.25 15V12.75C8.25 11.9216 7.57843 11.25 6.75 11.25Z" fill="black" />
                                    <path id="Vector_4" d="M15 8.25H11.25C10.4216 8.25 9.75 8.92157 9.75 9.75V15C9.75 15.8284 10.4216 16.5 11.25 16.5H15C15.8284 16.5 16.5 15.8284 16.5 15V9.75C16.5 8.92157 15.8284 8.25 15 8.25Z" fill="black" />
                                </g>
                            </g>
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2.5" :class="selectedOptionName === 'dashboard' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Dashboard</div>
                    </a>
                </div>
                <div v-if="displayToolTip == true && tipText == 'dashboard' && iconName == 'dashboard'" class="bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth pointer-events-none transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white">Dashboard</div>
				</div>
            </li>

            <li
                @mouseover="displayToolTipMethod('risks', 'Risks')"
                @click="navigate('risks', 'risks')"
                @mouseout="hideToolTip()"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'risks' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.2533 6.64111L12.5188 6.3576C12.4172 6.00953 12.2784 5.67495 12.1047 5.35828L13.1172 3.9152C13.1991 3.79869 13.185 3.63991 13.0843 3.53895L11.9429 2.39817C11.8411 2.29662 11.6809 2.28342 11.5641 2.36765L10.1427 3.38928C9.82309 3.2126 9.48558 3.07231 9.13545 2.97047L8.83287 1.24301C8.80822 1.10272 8.68642 1 8.54378 1H6.92961C6.7858 1 6.66312 1.10419 6.63994 1.24624L6.35936 2.96431C6.00718 3.06556 5.66908 3.20438 5.35065 3.37871L3.93311 2.36618C3.81601 2.28254 3.65664 2.29604 3.5548 2.39729L2.41402 3.53807C2.31335 3.63874 2.29927 3.79722 2.38115 3.91374L3.37871 5.34096C3.20115 5.66233 3.05969 6.00248 2.95668 6.35643L1.24535 6.6414C1.10389 6.66488 1 6.78756 1 6.93078V8.54496C1 8.6873 1.10213 8.8091 1.24213 8.83404L2.95345 9.13751C3.05587 9.49057 3.19734 9.83072 3.37548 10.153L2.36559 11.5655C2.28224 11.682 2.29545 11.842 2.3967 11.9438L3.53778 13.0858C3.63845 13.1865 3.79722 13.2005 3.91374 13.1187L5.34302 12.1176C5.6638 12.294 6.00278 12.434 6.35408 12.5355L6.64052 14.2556C6.66371 14.3968 6.78609 14.5004 6.92961 14.5004H8.54378C8.68612 14.5004 8.80792 14.3983 8.83258 14.2583L9.13927 12.5296C9.49116 12.426 9.82838 12.2852 10.1459 12.1085L11.5855 13.1184C11.7023 13.2008 11.8608 13.1865 11.9617 13.0858L13.1028 11.9438C13.2044 11.842 13.2176 11.6815 13.1333 11.5646L12.1067 10.1392C12.2808 9.82221 12.419 9.48705 12.5197 9.13898L14.2565 8.83404C14.3971 8.80939 14.4992 8.6873 14.4992 8.54496V6.93078C14.4995 6.78697 14.3953 6.66429 14.2533 6.64111ZM7.74961 9.8046C6.61499 9.8046 5.6952 8.88482 5.6952 7.7502C5.6952 6.61558 6.61499 5.69579 7.74961 5.69579C8.88423 5.69579 9.80402 6.61558 9.80402 7.7502C9.80402 8.88482 8.88423 9.8046 7.74961 9.8046Z"
                                fill="black"
                            />
                            <circle cx="11.9855" cy="11.9855" r="4.76484" fill="#1976d2" />
                            <path
                                class="risks"
                                d="M14.3365 13.216L12.4 9.64921C12.3488 9.55501 12.273 9.47638 12.1808 9.42159C12.0886 9.36681 11.9834 9.33789 11.8761 9.33789C11.7689 9.33789 11.6636 9.36681 11.5714 9.42159C11.4792 9.47638 11.4035 9.55501 11.3523 9.64921L9.41378 13.216C9.36305 13.3071 9.33707 13.4098 9.33843 13.5141C9.33979 13.6183 9.36846 13.7204 9.42156 13.8101C9.47466 13.8998 9.55035 13.974 9.64108 14.0254C9.73181 14.0767 9.83441 14.1034 9.93866 14.1027H13.8116C13.915 14.1028 14.0167 14.076 14.1066 14.025C14.1965 13.974 14.2716 13.9004 14.3245 13.8116C14.3775 13.7228 14.4064 13.6217 14.4085 13.5184C14.4106 13.415 14.3858 13.3129 14.3365 13.222V13.216ZM11.5789 10.6711C11.5789 10.592 11.6103 10.5162 11.6663 10.4603C11.7222 10.4043 11.798 10.3729 11.8771 10.3729C11.9562 10.3729 12.0321 10.4043 12.088 10.4603C12.1439 10.5162 12.1754 10.592 12.1754 10.6711V12.041C12.1754 12.1201 12.1439 12.1959 12.088 12.2519C12.0321 12.3078 11.9562 12.3392 11.8771 12.3392C11.798 12.3392 11.7222 12.3078 11.6663 12.2519C11.6103 12.1959 11.5789 12.1201 11.5789 12.041V10.6711ZM11.8851 13.3572C11.8175 13.3572 11.7513 13.3371 11.6951 13.2995C11.6389 13.2619 11.595 13.2085 11.5692 13.1461C11.5433 13.0836 11.5365 13.0148 11.5497 12.9485C11.5629 12.8821 11.5955 12.8212 11.6433 12.7734C11.6911 12.7256 11.752 12.693 11.8184 12.6798C11.8847 12.6666 11.9535 12.6734 12.016 12.6993C12.0784 12.7251 12.1318 12.769 12.1694 12.8252C12.207 12.8814 12.2271 12.9476 12.2271 13.0152C12.2271 13.1059 12.191 13.1929 12.1269 13.257C12.0628 13.3211 11.9758 13.3572 11.8851 13.3572Z"
                                fill="black"
                            />
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'risks' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Risks</div>
                    </a>
                </div>
            </li>
            <div :class="{ 'pl-4': isSidebarToggle, 'pl-0': !isSidebarToggle}" style="background-color:#f8f8f8">
            <li
                @mouseover="displayToolTipMethod('organization', 'Location Risk')"
                @mouseout="hideToolTip()"
                @click="navigate('organization', 'organization')"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'organization' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2328_26181)">
                                <path
                                    d="M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z"
                                    fill="black"
                                />
                                <path
                                    d="M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z"
                                    fill="black"
                                />
                                <path
                                    d="M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z"
                                    fill="black"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_2328_26181">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'organization' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Location Risk</div>
                    </a>
                </div>
            </li>
            <li
                @mouseover="displayToolTipMethod('businessProcess', 'Activity Risk')"
                @mouseout="hideToolTip()"
                @click="navigate('businessProcess', 'businessProcess')"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'businessProcess' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2328_26181)">
                                <path
                                    d="M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z"
                                    fill="black"
                                />
                                <path
                                    d="M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z"
                                    fill="black"
                                />
                                <path
                                    d="M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z"
                                    fill="black"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_2328_26181">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'businessProcess' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Activity Risk</div>
                    </a>
                </div>
            </li>
            <li
                @mouseover="displayToolTipMethod('systems', 'System Risk')"
                @mouseout="hideToolTip()"
                @click="navigate('systems', 'systems')"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'systems' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.19329 6.70056C9.19329 6.58592 9.12349 6.45254 9.03751 6.4029L4.25965 3.6444C4.11637 3.56165 4 3.64964 4 3.84069V13.7272C4 13.88 4.09309 14.0579 4.20773 14.1241L8.46623 16.5827C8.86751 16.8144 9.19329 16.5681 9.19329 16.0331V6.70056Z" fill="black" />
                            <path
                                d="M13.8513 3.93405C13.8513 3.86311 13.8081 3.83044 13.7549 3.86116L9.12719 6.53299C9.07399 6.56371 9.03076 6.64624 9.03076 6.71718V16.2166C9.03076 16.6068 9.26838 16.7864 9.56102 16.6174L13.7549 14.1961C13.8081 14.1654 13.8513 14.0828 13.8513 14.0119V3.93405Z"
                                fill="black"
                            />
                            <path
                                d="M9.3402 1.18313L9.36517 1.13989L9.34021 1.18313L13.5835 3.63296C13.7227 3.71332 13.7891 3.80825 13.7992 3.89004C13.8089 3.96793 13.7694 4.05149 13.6545 4.11778L9.47608 6.53022L9.50108 6.57352L9.47608 6.53022C9.36004 6.59723 9.19605 6.62851 9.02297 6.62133C8.85038 6.61417 8.67449 6.56897 8.53632 6.48919L8.51132 6.53249L8.53632 6.48919L4.29308 4.03936C4.15388 3.959 4.08748 3.86406 4.07731 3.78228C4.06762 3.70438 4.10718 3.62083 4.22199 3.55453L8.40045 1.1421C8.51649 1.07511 8.68048 1.04383 8.85356 1.051C9.02615 1.05816 9.20204 1.10335 9.3402 1.18313Z"
                                fill="black"
                                stroke="#1976d2"
                                stroke-width="0.1"
                            />
                            <path
                                d="M9.36521 11.218C9.07249 11.0489 8.62897 11.0305 8.37545 11.1769L4.19699 13.5894C3.9435 13.7357 3.97533 13.9918 4.26808 14.1608L8.51132 16.6106C8.80404 16.7797 9.24755 16.7981 9.50108 16.6517L13.6795 14.2392C13.9331 14.0929 13.9012 13.8368 13.6085 13.6678L9.36521 11.218Z"
                                fill="black"
                            />
                            <path class="systems" d="M8.95021 9.21027L4.02588 6.36719V6.92799L8.95021 9.77103V9.21027ZM13.6078 6.52117L8.95021 9.21027V9.77103L13.6078 7.08197V6.52117Z" fill="#1976d2" />
                            <path
                                class="systems"
                                d="M8.04777 11.1471C8.04777 11.1141 8.02775 11.0759 8.00308 11.0616L4.75615 9.18701C4.73148 9.17275 4.71143 9.18789 4.71143 9.22081V10.2939C4.71143 10.3268 4.73148 10.3651 4.75615 10.3794L8.00308 12.254C8.02775 12.2682 8.04777 12.2531 8.04777 12.2202V11.1471ZM8.04777 13.459C8.04777 13.4261 8.02775 13.3879 8.00308 13.3736L4.75615 11.499C4.73148 11.4848 4.71143 11.4999 4.71143 11.5328V12.6059C4.71143 12.6388 4.73148 12.6771 4.75615 12.6913L8.00308 14.566C8.02775 14.5802 8.04777 14.5651 8.04777 14.5322V13.459Z"
                                fill="black"
                            />
                            <path
                                d="M7.82789 6.47074C7.94932 6.54081 8.04787 6.76141 8.04787 6.96306C8.04787 7.16467 7.94932 7.27147 7.82789 7.20137C7.7065 7.13127 7.60791 6.91066 7.60791 6.70905C7.60791 6.50741 7.7065 6.40064 7.82789 6.47074ZM7.82789 7.49731C7.94932 7.56737 8.04787 7.78798 8.04787 7.98962C8.04787 8.19123 7.94932 8.29803 7.82789 8.22793C7.7065 8.15783 7.60791 7.93723 7.60791 7.73562C7.60791 7.53397 7.7065 7.42721 7.82789 7.49731Z"
                                fill="black"
                            />
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'systems' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">System Risk</div>
                    </a>
                </div>
            </li>
            <!-- <li
                @click="navigate('inActiveRisks', 'inActiveRisks')"
                @mouseover="displayToolTipMethod('inactive', 'Inactive')"
                @mouseout="hideToolTip()"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'inActiveRisks' ? 'bg-primary text-\white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.29463 2.10857C5.26034 2.07416 5.21959 2.04685 5.17472 2.02822C5.12985 2.00959 5.08174 2 5.03316 2C4.98457 2 4.93647 2.00959 4.8916 2.02822C4.84673 2.04685 4.80598 2.07416 4.77168 2.10857L2.81277 4.0561L2.11448 3.37565C2.08019 3.34124 2.03944 3.31393 1.99457 3.2953C1.9497 3.27667 1.90159 3.26708 1.85301 3.26708C1.80442 3.26708 1.75632 3.27667 1.71145 3.2953C1.66658 3.31393 1.62583 3.34124 1.59153 3.37565L1.10857 3.85922C1.07416 3.89352 1.04685 3.93427 1.02822 3.97914C1.00959 4.02401 1 4.07211 1 4.1207C1 4.16928 1.00959 4.21739 1.02822 4.26226C1.04685 4.30713 1.07416 4.34788 1.10857 4.38217L2.57252 5.84028C2.6456 5.90974 2.74256 5.94847 2.84338 5.94847C2.9442 5.94847 3.04117 5.90974 3.11424 5.84028L3.59381 5.35978L5.81481 3.13909C5.88401 3.06984 5.92311 2.97609 5.92363 2.87819C5.92415 2.78028 5.88604 2.68613 5.81758 2.61614L5.29463 2.10857ZM5.29463 7.00554C5.26034 6.97112 5.21959 6.94382 5.17472 6.92519C5.12985 6.90655 5.08174 6.89696 5.03316 6.89696C4.98457 6.89696 4.93647 6.90655 4.8916 6.92519C4.84673 6.94382 4.80598 6.97112 4.77168 7.00554L2.81277 8.96568L2.11448 8.28584C2.08019 8.25143 2.03944 8.22412 1.99457 8.20549C1.9497 8.18686 1.90159 8.17727 1.85301 8.17727C1.80442 8.17727 1.75632 8.18686 1.71145 8.20549C1.66658 8.22412 1.62583 8.25143 1.59153 8.28584L1.10857 8.76849C1.07416 8.80279 1.04685 8.84354 1.02822 8.88841C1.00959 8.93328 1 8.98138 1 9.02997C1 9.07855 1.00959 9.12666 1.02822 9.17153C1.04685 9.2164 1.07416 9.25715 1.10857 9.29144L2.56883 10.7526C2.64185 10.8221 2.73877 10.8608 2.83954 10.8608C2.9403 10.8608 3.03722 10.8221 3.11024 10.7526L3.5932 10.27L5.8142 8.04836C5.88313 7.97959 5.9221 7.88636 5.92262 7.78899C5.92314 7.69162 5.88517 7.59799 5.81697 7.52849L5.29463 7.00554ZM2.96874 12.3369C2.15386 12.3369 1.47402 12.9982 1.47402 13.8134C1.47402 14.6286 2.15447 15.29 2.96874 15.29C3.36034 15.29 3.73591 15.1344 4.01282 14.8575C4.28973 14.5806 4.4453 14.205 4.4453 13.8134C4.4453 13.4218 4.28973 13.0462 4.01282 12.7693C3.73591 12.4924 3.36034 12.3369 2.96874 12.3369ZM16.2578 12.829H7.39843C7.26789 12.829 7.1427 12.8809 7.0504 12.9732C6.9581 13.0655 6.90624 13.1907 6.90624 13.3212V14.3056C6.90624 14.4361 6.9581 14.5613 7.0504 14.6536C7.1427 14.7459 7.26789 14.7978 7.39843 14.7978H16.2578C16.3883 14.7978 16.5135 14.7459 16.6058 14.6536C16.6981 14.5613 16.75 14.4361 16.75 14.3056V13.3212C16.75 13.1907 16.6981 13.0655 16.6058 12.9732C16.5135 12.8809 16.3883 12.829 16.2578 12.829ZM16.2578 2.98528H7.39843C7.26789 2.98528 7.1427 3.03714 7.0504 3.12944C6.9581 3.22174 6.90624 3.34693 6.90624 3.47747V4.46185C6.90624 4.59238 6.9581 4.71757 7.0504 4.80988C7.1427 4.90218 7.26789 4.95403 7.39843 4.95403H16.2578C16.3883 4.95403 16.5135 4.90218 16.6058 4.80988C16.6981 4.71757 16.75 4.59238 16.75 4.46185V3.47747C16.75 3.34693 16.6981 3.22174 16.6058 3.12944C16.5135 3.03714 16.3883 2.98528 16.2578 2.98528ZM16.2578 7.90716H7.39843C7.26789 7.90716 7.1427 7.95902 7.0504 8.05132C6.9581 8.14362 6.90624 8.26882 6.90624 8.39935V9.38373C6.90624 9.51426 6.9581 9.63945 7.0504 9.73176C7.1427 9.82406 7.26789 9.87592 7.39843 9.87592H16.2578C16.3883 9.87592 16.5135 9.82406 16.6058 9.73176C16.6981 9.63945 16.75 9.51426 16.75 9.38373V8.39935C16.75 8.26882 16.6981 8.14362 16.6058 8.05132C16.5135 7.95902 16.3883 7.90716 16.2578 7.90716Z"
                                fill="black"
                            />
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'inActiveRisks' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Inactive</div>
                    </a>
                </div>
            </li> -->
            </div>
            <li
                @click="navigate('orginformation', 'orginformation')"
                @mouseover="displayToolTipMethod('information', 'Information')"
                @mouseout="hideToolTip()"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'orginformation' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Information">
                                <g id="Group">
                                    <path id="Vector" d="M12.3359 1.14453V4.44563H15.637L12.3359 1.14453Z" fill="black" />
                                    <path
                                        id="Vector_2"
                                        d="M12.0898 4.9375C11.9538 4.9375 11.8438 4.8275 11.8438 4.69141V1H2.98438C2.44026 1 2 1.44026 2 1.98438V15.7656C2 16.3097 2.44026 16.75 2.98438 16.75H14.7969C15.341 16.75 15.7812 16.3097 15.7812 15.7656V4.9375H12.0898ZM4.70703 5.42969H8.64453C8.78062 5.42969 8.89062 5.53969 8.89062 5.67578C8.89062 5.81187 8.78062 5.92188 8.64453 5.92188H4.70703C4.57094 5.92188 4.46094 5.81187 4.46094 5.67578C4.46094 5.53969 4.57094 5.42969 4.70703 5.42969ZM13.0742 13.5508H4.70703C4.57094 13.5508 4.46094 13.4408 4.46094 13.3047C4.46094 13.1686 4.57094 13.0586 4.70703 13.0586H13.0742C13.2103 13.0586 13.3203 13.1686 13.3203 13.3047C13.3203 13.4408 13.2103 13.5508 13.0742 13.5508ZM13.0742 12.0742H4.70703C4.57094 12.0742 4.46094 11.9642 4.46094 11.8281C4.46094 11.692 4.57094 11.582 4.70703 11.582H13.0742C13.2103 11.582 13.3203 11.692 13.3203 11.8281C13.3203 11.9642 13.2103 12.0742 13.0742 12.0742ZM13.0742 10.5977H4.70703C4.57094 10.5977 4.46094 10.4877 4.46094 10.3516C4.46094 10.2155 4.57094 10.1055 4.70703 10.1055H13.0742C13.2103 10.1055 13.3203 10.2155 13.3203 10.3516C13.3203 10.4877 13.2103 10.5977 13.0742 10.5977ZM13.0742 9.12109H4.70703C4.57094 9.12109 4.46094 9.01109 4.46094 8.875C4.46094 8.73891 4.57094 8.62891 4.70703 8.62891H13.0742C13.2103 8.62891 13.3203 8.73891 13.3203 8.875C13.3203 9.01109 13.2103 9.12109 13.0742 9.12109ZM13.0742 7.64453H4.70703C4.57094 7.64453 4.46094 7.53453 4.46094 7.39844C4.46094 7.26235 4.57094 7.15234 4.70703 7.15234H13.0742C13.2103 7.15234 13.3203 7.26235 13.3203 7.39844C13.3203 7.53453 13.2103 7.64453 13.0742 7.64453Z"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'orginformation' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Information</div>
                    </a>
                </div>
            </li>

            <li
                @click="navigate('business', 'business')"
                @mouseover="displayToolTipMethod('vendors', 'Vendors')"
                @mouseout="hideToolTip()"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'business' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2328_26181)">
                                <path
                                    d="M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z"
                                    fill="black"
                                />
                                <path
                                    d="M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z"
                                    fill="black"
                                />
                                <path
                                    d="M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z"
                                    fill="black"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_2328_26181">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'business' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Vendors</div>
                    </a>
                </div>
            </li>
            <li
                @mouseover="displayToolTipMethod('Tasks', 'Mitigation Tasks')"
                @mouseout="hideToolTip()"
                @click="navigate('myTasks', 'myTasks')"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'myTasks' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.29463 2.10857C5.26034 2.07416 5.21959 2.04685 5.17472 2.02822C5.12985 2.00959 5.08174 2 5.03316 2C4.98457 2 4.93647 2.00959 4.8916 2.02822C4.84673 2.04685 4.80598 2.07416 4.77168 2.10857L2.81277 4.0561L2.11448 3.37565C2.08019 3.34124 2.03944 3.31393 1.99457 3.2953C1.9497 3.27667 1.90159 3.26708 1.85301 3.26708C1.80442 3.26708 1.75632 3.27667 1.71145 3.2953C1.66658 3.31393 1.62583 3.34124 1.59153 3.37565L1.10857 3.85922C1.07416 3.89352 1.04685 3.93427 1.02822 3.97914C1.00959 4.02401 1 4.07211 1 4.1207C1 4.16928 1.00959 4.21739 1.02822 4.26226C1.04685 4.30713 1.07416 4.34788 1.10857 4.38217L2.57252 5.84028C2.6456 5.90974 2.74256 5.94847 2.84338 5.94847C2.9442 5.94847 3.04117 5.90974 3.11424 5.84028L3.59381 5.35978L5.81481 3.13909C5.88401 3.06984 5.92311 2.97609 5.92363 2.87819C5.92415 2.78028 5.88604 2.68613 5.81758 2.61614L5.29463 2.10857ZM5.29463 7.00554C5.26034 6.97112 5.21959 6.94382 5.17472 6.92519C5.12985 6.90655 5.08174 6.89696 5.03316 6.89696C4.98457 6.89696 4.93647 6.90655 4.8916 6.92519C4.84673 6.94382 4.80598 6.97112 4.77168 7.00554L2.81277 8.96568L2.11448 8.28584C2.08019 8.25143 2.03944 8.22412 1.99457 8.20549C1.9497 8.18686 1.90159 8.17727 1.85301 8.17727C1.80442 8.17727 1.75632 8.18686 1.71145 8.20549C1.66658 8.22412 1.62583 8.25143 1.59153 8.28584L1.10857 8.76849C1.07416 8.80279 1.04685 8.84354 1.02822 8.88841C1.00959 8.93328 1 8.98138 1 9.02997C1 9.07855 1.00959 9.12666 1.02822 9.17153C1.04685 9.2164 1.07416 9.25715 1.10857 9.29144L2.56883 10.7526C2.64185 10.8221 2.73877 10.8608 2.83954 10.8608C2.9403 10.8608 3.03722 10.8221 3.11024 10.7526L3.5932 10.27L5.8142 8.04836C5.88313 7.97959 5.9221 7.88636 5.92262 7.78899C5.92314 7.69162 5.88517 7.59799 5.81697 7.52849L5.29463 7.00554ZM2.96874 12.3369C2.15386 12.3369 1.47402 12.9982 1.47402 13.8134C1.47402 14.6286 2.15447 15.29 2.96874 15.29C3.36034 15.29 3.73591 15.1344 4.01282 14.8575C4.28973 14.5806 4.4453 14.205 4.4453 13.8134C4.4453 13.4218 4.28973 13.0462 4.01282 12.7693C3.73591 12.4924 3.36034 12.3369 2.96874 12.3369ZM16.2578 12.829H7.39843C7.26789 12.829 7.1427 12.8809 7.0504 12.9732C6.9581 13.0655 6.90624 13.1907 6.90624 13.3212V14.3056C6.90624 14.4361 6.9581 14.5613 7.0504 14.6536C7.1427 14.7459 7.26789 14.7978 7.39843 14.7978H16.2578C16.3883 14.7978 16.5135 14.7459 16.6058 14.6536C16.6981 14.5613 16.75 14.4361 16.75 14.3056V13.3212C16.75 13.1907 16.6981 13.0655 16.6058 12.9732C16.5135 12.8809 16.3883 12.829 16.2578 12.829ZM16.2578 2.98528H7.39843C7.26789 2.98528 7.1427 3.03714 7.0504 3.12944C6.9581 3.22174 6.90624 3.34693 6.90624 3.47747V4.46185C6.90624 4.59238 6.9581 4.71757 7.0504 4.80988C7.1427 4.90218 7.26789 4.95403 7.39843 4.95403H16.2578C16.3883 4.95403 16.5135 4.90218 16.6058 4.80988C16.6981 4.71757 16.75 4.59238 16.75 4.46185V3.47747C16.75 3.34693 16.6981 3.22174 16.6058 3.12944C16.5135 3.03714 16.3883 2.98528 16.2578 2.98528ZM16.2578 7.90716H7.39843C7.26789 7.90716 7.1427 7.95902 7.0504 8.05132C6.9581 8.14362 6.90624 8.26882 6.90624 8.39935V9.38373C6.90624 9.51426 6.9581 9.63945 7.0504 9.73176C7.1427 9.82406 7.26789 9.87592 7.39843 9.87592H16.2578C16.3883 9.87592 16.5135 9.82406 16.6058 9.73176C16.6981 9.63945 16.75 9.51426 16.75 9.38373V8.39935C16.75 8.26882 16.6981 8.14362 16.6058 8.05132C16.5135 7.95902 16.3883 7.90716 16.2578 7.90716Z"
                                fill="black"
                            />
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'myTasks' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Mitigation Tasks</div>
                    </a>
                </div>
            </li>

            <li
                @click="navigate('approvals', 'approvals')"
                @mouseover="displayToolTipMethod('approvals', 'Approvals')"
                @mouseout="hideToolTip()"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'approvals' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Approvals">
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        id="Vector"
                                        d="M7.90239 1.47362C8.15336 1.22247 8.56041 1.22232 8.81151 1.47327L10.7431 3.40332C10.8638 3.52395 10.9316 3.68764 10.9315 3.85831C10.9315 4.02898 10.8636 4.19262 10.7427 4.31316L8.81119 6.24025C8.55984 6.49101 8.15278 6.49056 7.90206 6.2392C7.65129 5.98785 7.65174 5.58082 7.90309 5.33006L8.72904 4.50604C5.83707 4.64727 3.53571 7.03673 3.53571 9.96373C3.53571 12.9816 5.98216 15.428 9 15.428C11.9204 15.428 14.3061 13.1366 14.4567 10.254C14.4752 9.89938 14.7777 9.627 15.1322 9.64551C15.4868 9.66403 15.7592 9.96649 15.7407 10.321C15.5546 13.8832 12.6081 16.7137 9 16.7137C5.27208 16.7137 2.25 13.6917 2.25 9.96373C2.25 6.3231 5.1322 3.35564 8.73932 3.21867L7.90277 2.38276C7.65161 2.1318 7.65148 1.72477 7.90239 1.47362Z"
                                        fill="black"
                                    />
                                    <path
                                        id="Vector_2"
                                        d="M11.7048 7.90117C11.9559 8.1522 11.9559 8.55926 11.7048 8.8103L8.49056 12.0246C8.37002 12.1451 8.20648 12.2129 8.03599 12.2129C7.86551 12.2129 7.70197 12.1451 7.58143 12.0246L6.29571 10.7389C6.04466 10.4878 6.04466 10.0808 6.29571 9.82974C6.54675 9.5787 6.95381 9.5787 7.20484 9.82974L8.03599 10.6609L10.7957 7.90117C11.0468 7.65013 11.4538 7.65013 11.7048 7.90117Z"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'approvals' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Approvals</div>
                    </a>
                </div>
            </li>

            

            <li
                @mouseover="displayToolTipMethod('vulnerabilities', 'Vulnerabilities')"
                @mouseout="hideToolTip()"
                @click="navigate('orgvulnerabilities', 'orgvulnerabilities')"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'orgvulnerabilities' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.36074 12.0406V10.2688H11.217C11.0201 11.1687 10.2607 11.9 9.36074 12.0406ZM9.92324 9.48125H11.217C11.1607 9.14375 11.0482 8.83437 10.8514 8.55312L9.92324 9.48125ZM8.54512 12.0406V10.2969H6.77324C6.97012 11.1688 7.70137 11.8719 8.54512 12.0406ZM9.36074 2V4.10938C10.6545 4.19375 11.8357 4.7 12.7639 5.51562L14.2826 3.99688C12.9326 2.84375 11.217 2.08438 9.36074 2ZM14.817 4.5875L13.2982 6.10625C14.0857 7.03438 14.592 8.1875 14.6764 9.48125H16.8701C16.7576 7.59688 16.0264 5.88125 14.817 4.5875ZM6.77324 9.48125H8.54512V7.625C7.64512 7.79375 6.91387 8.525 6.77324 9.48125ZM9.36074 4.925V6.78125C9.95137 6.8375 10.4295 7.0625 10.8795 7.4L12.2014 6.07812C11.3857 5.43125 10.4295 5.00937 9.36074 4.925ZM9.36074 7.59687V8.89062L10.2889 7.9625C10.0076 7.79375 9.72637 7.65312 9.36074 7.59687ZM3.28574 9.48125C3.45449 6.64062 5.70449 4.33438 8.54512 4.1375V2C4.52324 2.225 1.31699 5.45938 1.12012 9.48125H3.28574ZM8.54512 15.5281C5.76074 15.3313 3.51074 13.0813 3.28574 10.2969H1.12012C1.31699 14.2906 4.52324 17.525 8.54512 17.75V15.5281ZM14.6764 10.2688C14.4514 13.0813 12.1732 15.3313 9.33262 15.5V17.75C13.4107 17.5531 16.6451 14.3188 16.842 10.2688H14.6764ZM8.54512 14.7125V12.8562C7.19512 12.6594 6.18262 11.6188 5.95762 10.2969H4.10137C4.32637 12.6313 6.18262 14.5156 8.54512 14.7125ZM4.10137 9.48125H5.95762C6.12637 8.10313 7.19512 7.00625 8.54512 6.80938V4.95312C6.18262 5.15 4.27012 7.0625 4.10137 9.48125ZM13.8889 10.2688H12.0326C11.8357 11.6188 10.767 12.6875 9.36074 12.8562V14.7125C11.7514 14.5438 13.6639 12.6594 13.8889 10.2688ZM11.442 7.99062C11.7514 8.4125 11.9764 8.91875 12.0326 9.48125H13.8889C13.8045 8.4125 13.4107 7.45625 12.7357 6.66875L11.442 7.99062Z"
                                fill="black"
                            />
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'orgvulnerabilities' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Vulnerabilities</div>
                    </a>
                </div>
            </li>

            <li
                @click="navigate('orgthreat', 'orgthreat')"
                @mouseover="displayToolTipMethod('threat', 'Threat')"
                @mouseout="hideToolTip()"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName === 'orgthreat' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Threat" clip-path="url(#clip0_2395_30652)">
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        id="Vector"
                                        d="M15.0057 3.81591C13.9242 3.52726 12.8676 3.15219 11.8461 2.69432C10.8412 2.25838 9.87111 1.74621 8.94432 1.16227L8.68182 1L8.42409 1.16705C7.4973 1.75098 6.5272 2.26316 5.52227 2.69909C4.49914 3.15557 3.44096 3.52905 2.35795 3.81591L2 3.90659V7.88705C2 14.2777 8.4575 16.6689 8.51955 16.6927L8.68182 16.75L8.84409 16.6927C8.91091 16.6927 15.3636 14.2825 15.3636 7.88705V3.90659L15.0057 3.81591ZM12.8245 6.98977L7.49341 12.1682L4.47705 9.14705C4.35046 9.02046 4.27935 8.84878 4.27935 8.66977C4.27935 8.49076 4.35046 8.31908 4.47705 8.1925C4.60363 8.06592 4.77531 7.99481 4.95432 7.99481C5.13333 7.99481 5.30501 8.06592 5.43159 8.1925L7.50773 10.3068L11.8939 6.01136C11.9565 5.94869 12.0309 5.89897 12.1128 5.86505C12.1947 5.83113 12.2825 5.81367 12.3711 5.81367C12.4598 5.81367 12.5475 5.83113 12.6294 5.86505C12.7113 5.89897 12.7857 5.94869 12.8484 6.01136C12.9111 6.07404 12.9608 6.14845 12.9947 6.23034C13.0286 6.31223 13.0461 6.4 13.0461 6.48864C13.0461 6.57727 13.0286 6.66504 12.9947 6.74693C12.9608 6.82882 12.9111 6.90323 12.8484 6.96591L12.8245 6.98977Z"
                                        fill="black"
                                    />
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_2395_30652">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        </div>
                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'orgthreat' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Threat</div>
                    </a>
                </div>
            </li>

            <li
                @click="navigate('labelDefinitions', 'labelDefinitions')"
                @mouseover="displayToolTipMethod('labelDefinitions', 'labelDefinitions')"
                @mouseout="hideToolTip()"
                class="cursor-pointer text-black hover:bg-primary svg-icon pl-1.5 pr-2.5 adjustWidthWhenHover mt-1"
                :class="selectedOptionName == 'labelDefinitions' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
            >
                <div>
                    <a class="flex navchild items-center hover:text-white py-1.5">
                        <div class="py-0.5">
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_7041_46449)">
                                <rect y="5.72656" width="4.90909" height="6.54545" rx="0.5" fill="black" />
                                <rect x="12.6362" width="4.90909" height="3.27273" rx="0.5" fill="black" />
                                <rect x="12.6362" y="7.36328" width="4.90909" height="3.27273" rx="0.5" fill="black" />
                                <rect x="12.6362" y="14.7266" width="4.90909" height="3.27273" rx="0.5" fill="black" />
                                <path d="M12 1.63623H8.54541C7.99313 1.63623 7.54541 2.08395 7.54541 2.63623V15.3635C7.54541 15.9158 7.99313 16.3635 8.54541 16.3635H12" stroke="black" />
                                <path d="M5.5 9H12" stroke="black" />
                            </g>
                            <defs>
                                <clipPath id="clip0_7041_46449">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        </div>

                        <div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'labelDefinitions' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Label Definitions</div>
                    </a>
                </div>
            </li>

        </ul>
        
        <ul class="bottomUl ">
			<li class="relative">
				<hr class="mb-4" />
				<img src="@/assets/leftArrowIcon.svg" class=" icon   arrowIcon leftarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-if="isSidebarToggle" />
				<img src="@/assets/rightArrowIcon.svg" class="arrowiconRight  icon  rightarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-else />
			</li>
            <li class="mt-2 setting">
                <a @click="triggerNavToSettings()" class="flex navchild items-center pl-1.5 pr-2.5">
                    <div class="py-0.5">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.463 7.58168L14.4393 7.2509C14.3209 6.84478 14.1589 6.45442 13.9562 6.08495L15.1375 4.40127C15.2331 4.26533 15.2166 4.08008 15.0992 3.96228L13.7675 2.63129C13.6487 2.51282 13.4617 2.49741 13.3254 2.59568L11.6671 3.78765C11.2942 3.58151 10.9004 3.41783 10.4919 3.29901L10.1389 1.28352C10.1101 1.11985 9.96801 1 9.80159 1H7.91827C7.75049 1 7.60736 1.12156 7.5803 1.28729L7.25295 3.29182C6.84205 3.40996 6.44758 3.57192 6.07605 3.77532L4.42216 2.59397C4.28553 2.49638 4.0996 2.51213 3.98078 2.63027L2.64978 3.96126C2.53233 4.07871 2.5159 4.26362 2.61143 4.39956L3.77532 6.06475C3.56816 6.4397 3.40311 6.83657 3.28292 7.24953L1.28626 7.58202C1.12122 7.60941 1 7.75254 1 7.91964V9.80296C1 9.96904 1.11916 10.1111 1.2825 10.1402L3.27915 10.4943C3.39866 10.9062 3.56371 11.3031 3.77156 11.6791L2.59329 13.3272C2.49604 13.4631 2.51145 13.6497 2.62958 13.7685L3.96091 15.1009C4.07837 15.2183 4.26362 15.2348 4.39956 15.1392L6.06715 13.9713C6.44141 14.177 6.83691 14.3404 7.24679 14.4589L7.58099 16.4658C7.60804 16.6305 7.75083 16.7514 7.91827 16.7514H9.80159C9.96766 16.7514 10.1098 16.6322 10.1385 16.4689L10.4964 14.452C10.9069 14.3311 11.3004 14.1668 11.6709 13.9606L13.3504 15.1389C13.4867 15.2351 13.6716 15.2183 13.7894 15.1009L15.1208 13.7685C15.2392 13.6497 15.2546 13.4624 15.1564 13.3261L13.9586 11.663C14.1616 11.2932 14.3229 10.9021 14.4404 10.496L16.4668 10.1402C16.6308 10.1115 16.75 9.96904 16.75 9.80296V7.91964C16.7503 7.75186 16.6288 7.60873 16.463 7.58168ZM8.875 11.2726C7.5512 11.2726 6.47805 10.1995 6.47805 8.87568C6.47805 7.55188 7.5512 6.47874 8.875 6.47874C10.1988 6.47874 11.2719 7.55188 11.2719 8.87568C11.2719 10.1995 10.1988 11.2726 8.875 11.2726Z" fill="black"/>
                    </svg>
                    </div>
                    <div class="item-name leading-5 text-sm text-black pl-2" v-if="isSidebarToggle">Settings</div>
                </a>

            </li>
        </ul>

        <div class="fixed shadow z-50 bg-white w-40 px-2 py-1 min-h-30 flex flex-col justify-center" v-if="appsVisible">
            <div class="flex flex-row items-center">
                <div class="flex flex-row w-2/4 items-center cursor-pointer" @click="triggerNavigation()">
                    <img src="../assets/training.svg" alt="" class="icn h-8 w-8" />
                    <div class="nav-item-label-container ml-4">
                        <div class="text-sm font-semibold">Training</div>
                        <div class="active-border"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="toolTipActive">
        <tool-tip :tipText="toolTipText" :iconName="selectedOptionName" :combinations="combinations"></tool-tip>
    </div>
</template>
<style  scoped>
.crystaSureShield{
	padding-top:33px ;
	width:20px;
	margin-right: 10px;
}
.crystaSureLogo
{
	padding-top:20px ;
	margin-right: 13px;
	width:150px;
}
.sideheight{
	height: 100%;
    z-index: 50;
	padding-top:85px;
	border-right:1px solid rgb(233, 233, 233);
}
.mainlogo{
	position:fixed;
	margin-left:9px;
	z-index:52;
}
.setting{
    height: 35px;
    margin-top: 5px;
}
.bottomUl{
    height: 51px;
}

.sideLabels{
    height: 92%;
    overflow-y: auto;
}
::-webkit-scrollbar {
    width: 3px !important;
}
::-webkit-scrollbar-thumb {
  background: var(--color-primary) !important; 
  border-radius: 5px;
}
.sideToolTip {
    background: var(--color-primary);
    color: white;
    padding: 5px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px !important;
    font-size: 14px;
}
.tooltipwidth {
    width: auto;
	z-index : 200 !important
}
.bg-tooltip{
    background-color: var(--color-primary);
    border-radius: 3px;
}

.transform-y-top{
    transform: translateY(-28px);
}
.shadow {
    --tw-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.25);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.leftarrow,
.rightarrow {
    /* height: 1.25rem;
    width: 1.25rem; */
    margin-top: -27px;
}
.arrowIcon{
	height:22px;
	width:22px;
	margin-left:157px;
}
.arrowiconRight{
	height:22px;
	width:22px;
	margin-left:29px;
}


.a:hover {
    color: white;
    font-weight: bold;
}
.svg-icon:hover {
    color:white;
}
.svg-icon123 div a svg path,
.svg-icon123 div a svg rect,
.svg-icon:hover path,
.svg-Image:hover svg path,
.svg-Image:hover svg rect,
.svg-icon:hover rect {
    fill: white;
}
.svg-icon123 div a svg path.systems,
.svg-icon:hover path.systems {
    fill: #e9e9e9;
}

.svg-icon123 div a svg path.risks,
.svg-icon:hover path.risks {
    fill: #e9e9e9;
}

::-webkit-scrollbar {
    width: 10px;
}
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 3px grey;
    border-radius: 10px;
}
::-webkit-scrollbar-thumb {
    background: gray;
    border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
    background: gray;
}
.adjustWidthWhenHover{
    border-radius: 5px;
    margin-left:3px;
    margin-right:3px;
}
</style>
<script lang="ts">
import { mapGetters } from 'vuex';

import { defineComponent } from 'vue';
import { emitter } from '../main';
import toolTip from '@/components/menuBarToolTip.vue'
import store from '../store';
import { create } from 'lodash';
import { last } from 'lodash';
export default defineComponent({
    data(): any {
        return {
            resizeTimeout:0,
            isSidebarToggle: true,
            controlsShows: false,
            taskShows: false,
            appsVisible: false,
            dashboard: false,
            viewConfiguration: false,
            tasks: false,
            viewKpis: false,
            sideNavSelected: '',
            selectedOptionName: '',
            a: 0,
            menus: [
                {
                    optionName: 'dashboard',
                    optionRoute: 'dashboard',
                    defaultoptionImage: require('../assets/Tasks.svg'),
                    colouredoptionImage: require('../assets/MyTasksColored.svg'),
                    displayOptionName: 'Dashboard',
                    id: 20001
                },
                {
                    optionName: 'business',
                    optionRoute: 'business',
                    defaultoptionImage: require('@/assets/Business.svg'),
                    colouredoptionImage: require('@/assets/BusinessColored.svg'),
                    displayOptionName: 'Business',
                    id: 20001
                },
                {
                    optionName: 'orginformation',
                    optionRoute: 'orginformation',
                    defaultoptionImage: require('../assets/Informationpage.svg'),
                    colouredoptionImage: require('../assets/InformationColored.svg'),
                    displayOptionName: 'Information',
                    id: 20002
                },
                // {
                //     optionName: 'orgtvmapping',
                //     optionRoute: 'orgtvmapping',
                //     defaultoptionImage: require('../assets/kpiDefault.svg'),
                //     colouredoptionImage: require('../assets/kpiColoured.svg'),
                //     displayOptionName: 'RiskMaster',
                //     id:20003
                // },
                // {
                //     optionName: 'mapping',
                //     optionRoute: 'mapping',
                //     defaultoptionImage: require('@/assets/kpiDefault.svg'),
                //     colouredoptionImage: require('@/assets/kpiColoured.svg'),
                //     displayOptionName: 'Mapping',
                //     id:20004
                // },
                {
                    optionName: 'systems',
                    optionRoute: 'systems',
                    defaultoptionImage: require('../assets/Systems.svg'),
                    colouredoptionImage: require('../assets/SystemsColored.svg'),
                    displayOptionName: 'Systems',
                    id: 20005
                },
                {
                    optionName: 'infoClassifications',
                    optionRoute: 'infoClassifications',
                    defaultoptionImage: require('../assets/Info_Classification.svg'),
                    colouredoptionImage: require('../assets/Info_Classification_Selected.svg'),
                    displayOptionName: 'infoClassifications',
                    id: 20005
                },

                {
                    optionName: 'risks',
                    optionRoute: 'risks',
                    defaultoptionImage: require('../assets/Risks.svg'),
                    colouredoptionImage: require('../assets/RisksColored.svg'),
                    displayOptionName: 'Risks',
                    id: 20006
                },
                {
                    optionName: 'myTasks',
                    optionRoute: 'myTasks',
                    defaultoptionImage: require('../assets/Tasks.svg'),
                    colouredoptionImage: require('../assets/MyTasksColored.svg'),
                    displayOptionName: 'Tasks',
                    id: 20007
                },
                {
                    optionName: 'approvals',
                    optionRoute: 'approvals',
                    defaultoptionImage: require('../assets/Tasks.svg'),
                    colouredoptionImage: require('../assets/MyTasksColored.svg'),
                    displayOptionName: 'Approvals',
                    id: 20007
                },
                {
                    optionName: 'inActiveRisks',
                    optionRoute: 'inActiveRisks',
                    defaultoptionImage: require('../assets/Tasks.svg'),
                    colouredoptionImage: require('../assets/MyTasksColored.svg'),
                    displayOptionName: 'InActive',
                    id: 20007
                }
            ],
            displayToolTip: false,
            tiptext: '',
            iconName: '',

            toolTipActive : false,
            toolTipText : '',

            combinations:[
                {tiptext:'Dashboard',option:'dashboard'},
                {tiptext:'Vendors',option:'business'},
                {tiptext:'Activity Risk',option:'businessProcess'},
                {tiptext:'Location Risk',option:'organization'},
                {tiptext:'Information',option:'orginformation'},
                {tiptext:'System Risk',option:'systems'},
                {tiptext:'Risks',option:'risks'},
                {tiptext:'Tasks',option:'myTasks'},
                {tiptext:'Approvals',option:'approvals'},
                {tiptext:'InActive',option:'inActiveRisks'},
                {tiptext:'Vulnerabilities',option:'orgvulnerabilities'},
                {tiptext:'Threat',option:'orgthreat'},
                {tiptext:'Labels',option:'labelDefinitions'}
            ]
        };
    },
    methods: {
        displayToolTipMethod(name: any, tiptext: any) {
            if (this.isSidebarToggle == false) {
                this.displayToolTip = true;
                this.tipText = tiptext;
                this.iconName = name;
                this.toolTipActive = true;
                if(tiptext == 'labelDefinitions'){
                    this.toolTipText = 'Labels';
                    this.iconName = name;
                }else{
                    this.toolTipText = tiptext;
                    this.iconName = name;
                }
            }
        },
        hideToolTip() {
            this.toolTipActive = false;
            this.toolTipText = '';
            this.iconName = ''
            this.displayToolTip = false;
            // emitter.emit('deActiviteToolTip')
        },
        controlsShow() {
            this.controlsShows = !this.controlsShows;
        },
        tasksShow() {
            this.taskShows = !this.taskShows;
        },
        toggleSideMenuBar() {
            this.isSidebarToggle = !this.isSidebarToggle;
            this.$store.dispatch('selectedToggle', this.isSidebarToggle);
            emitter.emit('toggle-sidebar', this.isSidebarToggle);
        },
        triggerNavToSettings() {
            window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_ORG_UI}`;
        },
        navigate(name: any, routerOption: any) {
            this.$store.dispatch('selectedToggle', this.isSidebarToggle);
            this.$store.dispatch('selectedRoute', name);
            this.$router.push({ name: routerOption });
        },
        triggerNavigation() {
            window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_TRAINING_UI}`;
        },
        debouncedHandleResize() {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.handleResize, 100); // Adjust debounce time as needed
        },
        handleResize() {
            if(window.innerWidth<1164)
            {
                this.$store.dispatch('selectedToggle', false);
                this.isSidebarToggle = false;
                emitter.emit('toggle-sidebar', this.isSidebarToggle);
            }
            else if(this.isSidebarToggle == false){
                this.$store.dispatch('selectedToggle', true);
                this.isSidebarToggle = true;
                emitter.emit('toggle-sidebar', this.isSidebarToggle);
            }
        },
    },
    components:{
        toolTip
    },  
    computed: {
        currentRouteName():any {
            return this.$route.name;
        },
        ...mapGetters({
            userInfo: 'userInfo',
            toggleState: 'toggle'
        })
        // ...mapGetters({ selectedOptionName: 'val' })
    },

    mounted() {
        window.addEventListener('resize', this.debouncedHandleResize);
        let passingRouteName;
        if (
            (Object.keys(this.$route.query).includes('Risks') && this.$route.query.Risks == 'true') ||
            (Object.keys(this.$route.query).includes('risks') && this.$route.query.risks == 'true')||
            this.$route.path.includes('/processRisks') ||
            this.$route.path.includes('/orgRisks') ||
            this.$route.path.includes('/systemRisks') ||
            (this.$route.path.includes('/ControlsMap') && Object.keys(this.$route.query).includes('Risks')) ||
            this.$route.query.tierRisks == 'true' || this.$route.path.includes('/ControlsMap/risks')
        ) {
            passingRouteName = 'risks';
        } else if (this.$route.path.includes('/org/infoClassifications') || this.$route.path.includes('/informations/classification')) {
            passingRouteName = 'infoClassifications';
        } else if (this.$route.path.includes('/org/information')) {
            passingRouteName = 'orginformation';
        } else if (
            (this.$route.path.includes('/worklog/org') && Object.keys(this.$route.query).includes('organization')) ||
            this.$route.query.organization == 'true' ||
            (this.$route.path.includes('/ControlsMap') && Object.keys(this.$route.query).includes('organization')) ||
            this.$route.path.includes('/organizationInformation')
        ) {
            passingRouteName = 'organization';
        } else if (
            this.$route.path.includes('/org/businessProcess') ||
            this.$route.query.process == 'true' ||
            (this.$route.path.includes('/ControlsMap') && Object.keys(this.$route.query).includes('process')) ||
            (this.$route.path.includes('/worklog/process') && Object.keys(this.$route.query).includes('process')) ||
            this.$route.path.includes('/processInformation')
        ) {
            passingRouteName = 'businessProcess';
        } else if (
            this.$route.path.includes('/systemInformation') ||
            this.$route.query.systems == 'true' ||
            (this.$route.path.includes('/worklog/system') && Object.keys(this.$route.query).includes('systems')) ||
            (this.$route.path.includes('/ControlsMap') && Object.keys(this.$route.query).includes('systems'))
        ) {
            passingRouteName = 'systems';
        } else if (this.$route.path.includes('/inActive')|| this.$route.query.inActive === 'true') {
            passingRouteName = 'inActiveRisks';
        } else if (Object.keys(this.$route.query).includes('approvals')) {
            passingRouteName = 'approvals';
        } else if (this.$route.path.includes('task') || this.$route.path.includes('myTasks')) {
            passingRouteName = 'myTasks';
        } else {
            passingRouteName = this.currentRouteName;
        }

        this.selectedOptionName = passingRouteName;
        emitter.on('apps-sidemenubar', (isToggle) => {
            this.appsVisible = isToggle;
        });
        emitter.on('apps', (isToggle: any) => {
            this.appsVisible = isToggle;
        });
        this.isSidebarToggle = this.toggleState;
        
    },

    created() {
        this.handleResize()
        this.menus.forEach((menu: any) => {
            menu.userRole = this.userInfo.currentRole;
        });
    },
     beforeUnmount() {
        window.removeEventListener('resize', this.debouncedHandleResize);
    },
});
</script>







